import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InstanceModuleService } from 'src/app/areas/kms/serves/instance/instance.module';
import { SwAudioService } from 'src/app/librarys/components/basic-components/sw-audio/sw-audio.service';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { EditDatasourceComponent } from '../../edit-datasource/edit-datasource.component';
declare var $;
@Component({
  selector: 'app-mark-view',
  templateUrl: './mark-view.component.html',
  styleUrls: ['./mark-view.component.css']
})
export class MarkViewComponent implements OnInit {
  //接收父组件的数据  
  @Input() bigImgUrl:string;              // 图片路径
  @Input() currentMarkId:string;          // 标记id,新增时默认为空
  @Input() showMarkDetail:boolean;        // 标注编辑组件是否显示 
  @Input() modalStyle:boolean = false;        // 是否添加弹出框中显示的样式
  // 执行与区域图描边有关的操作时触发
  @Output('strokeOpe') strokeOpe = new EventEmitter<any>();
  // 执行与取点定位有关的操作时触发
  @Output('pointOpe') pointOpe = new EventEmitter<any>();
  // 数据绑定对象
  markModel: any = {}; 
  // tab切换当前模块id
  tabId:string = 'markInfo'
  // 标签数据
  selectedTags:any = [];
  // 音频文件名称
  audioName:string = '';
  // 是否展示描边
  isShowStroke = false;
  // 是否展示定位点
  isShowPoint = false;
  // 数据来源
  sourceList:any = [];
  constructor(
    private create: SwCreateModalComponentService,
    private instanceModuleService: InstanceModuleService,
    private box: SwMassageBoxService,
    private kmsService: KmsService,
    private swAudioService: SwAudioService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.showMarkDetail && this.currentMarkId){
      // tab选项卡初始化
      this.tabId = 'markInfo';
      this.isShowStroke = false;
      this.isShowPoint = false;
      
      const format = this.instanceModuleService.getImgFormat(this.bigImgUrl);
      // 查询标注信息
      this.kmsService.queryImgMarkById(this.currentMarkId).subscribe(
        data => {
          if (data.code == '200') {
            let res = data.data;
            this.markModel.fileInfoId = res.fileInfoId ? res.fileInfoId : '';
            this.markModel.imageMarkId = res.imageMarkId;
            this.markModel.markName = res.markName;
            this.markModel.markNote = res.markNote;
            this.markModel.markNoteAudio = res.markNoteAudio;
            this.markModel.point = res.point ? res.point : '';
            this.markModel.points = res['points'] ? JSON.parse(res['points']) : [];
            this.markModel.imgUrl = this.bigImgUrl + res.position + ',' + res.width + ',' + res.height + '/full/0/default.' + format;
            this.markModel.width = res.width;
            this.markModel.height = res.height;
            this.markModel.position = res.position;
            this.markModel.instance = res.instance;
            this.markModel.masksImgPath1 = res.masksImgPath ? environment.staticFileUrl + res.masksImgPath : '';
            this.markModel.sortNum = res.sortNum;
            this.selectedTags = res.tags && res.tags.length>0 ? res.tags : [];
            this.sourceList = res.datasources && res.datasources.length>0 ? res.datasources : [];
            if(this.markModel.markNoteAudio){
              let path = this.markModel.markNoteAudio.split('/');
              this.audioName = path[path.length - 1];
            }
          } else {
            this.box.waring('标记信息查询失败！');
          }
        }
      );
    }
  }

  // 查看描边/关闭描边功能
  drawStroke(state){
    if(this.markModel.points.length == 0){
      return;
    }
    if(this.isShowPoint){
      this.isShowPoint = false;
    }
    if(state == 'open'){
      this.isShowStroke = true;
    }else{
      this.isShowStroke = false;
    }
    // 向父组件发射数据
    this.strokeOpe.emit({state: state});
  }

  // 查看定位坐标/关闭定位坐标功能
  drawPoint(state){
    if(!this.markModel.point){
      return;
    }
    if(this.isShowStroke){
      this.isShowStroke = false;
    }
    if(state == 'open'){
      this.isShowPoint = true;
    }else{
      this.isShowPoint = false;
    }
    // 向父组件发射数据
    this.pointOpe.emit({state: state});
  }

  // tab切换
  handleTabClick(id){
    this.tabId = id;
  }

  // 音频试听方法
  audioPlay() {
    if(this.markModel.markNoteAudio){
      let title = this.markModel.markName ? this.markModel.markName : '音频播放';
      this.swAudioService.openAudio(title, environment.staticFileUrl + this.markModel.markNoteAudio);
    }
  }

  // 查看来源方法
  handleSourceEditClick() {
    const data = {
        state: 'view',
        sourceList: this.sourceList
    }
    this.create.createModal(EditDatasourceComponent, data);
  }
}

